import React, { FC, forwardRef } from 'react';
import {
  TableHeadProps,
  TableBodyProps,
  TableContainerProps as MuiTableContainerProps,
  TableSortLabelProps as MuiTableSortLabelProps,
  TableCellProps
} from '@mui/material';
import {
  StyledTableContainer,
  StyledTable,
  StyledTableBody,
  StyledTableCell,
  StyledTableHead,
  StyledTableRow,
  StyledTableSortLabel
} from './styled';
import { TableProps, TableRowProps, StyledTableRowProps } from '../types';
import { Tooltip } from '../tooltip';
import { IconButton } from '../icon-button';
import { IconArrowDropUp, IconArrowDropDown } from '@mzc-cloudplex/icons';

type extendedTableContainerProps = TableProps & MuiTableContainerProps;

export const TableHead: FC<TableHeadProps> = (props) => <StyledTableHead {...props} />;

export const TableBody: FC<TableBodyProps> = (props) => <StyledTableBody {...props} />;

export const TableRow = forwardRef<HTMLTableRowElement, StyledTableRowProps>((props, ref) => (
  <StyledTableRow ref={ref} {...props} />
));

export const TableCell: FC<TableCellProps> = (props) => <StyledTableCell {...props} />;
export const TableSortLabel: FC<MuiTableSortLabelProps> = (props) => (
  <StyledTableSortLabel {...props} />
);

export const Table = React.forwardRef<HTMLTableElement, TableProps>((props, ref) => {
  return <StyledTable {...props} ref={ref} />;
});
export const TableContainer: FC<extendedTableContainerProps> = (props) => {
  return <StyledTableContainer {...props} />;
};

export const DropdownIndicator = ({ active, direction }: any) => (
  <div
    className={'DropdownIndicator'}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'space-between',
      flexDirection: 'column',
      marginLeft: `5px`
    }}
  >
    <Tooltip title={'오름차순 정렬'}>
      <IconButton color={'inherit'} circled sx={{ width: `18px`, height: `18px` }}>
        <IconArrowDropUp
          size={6}
          htmlColor={active && direction === 'asc' ? '#3c3d4f' : '#3c3d4f80'}
        />
      </IconButton>
    </Tooltip>
    <Tooltip title={'내림차순 정렬'}>
      <IconButton color={'inherit'} circled sx={{ width: `18px`, height: `18px` }}>
        <IconArrowDropDown
          size={6}
          htmlColor={active && direction === 'desc' ? '#3c3d4f' : '#3c3d4f80'}
        />
      </IconButton>
    </Tooltip>
  </div>
);
